import React, { useEffect, useState } from "react";
import HomePage from "./HomePage";
import { useNavigate } from "react-router-dom"
import CapturePage from "./CapturePage";
import HistoryPage from "./HistoryPage";
import BottomNav from "./BottomNav";
import logo from "../../assets/image/favicon_0.png";
import { getSeedRecords, mockCurrentEmployee, fetchKaryawan, resolveStatus } from "../../controller/mobile/mockapi";
import type { AttendanceRecord, AttendanceType, CaptureResult, Karyawan, Page } from "../../controller/mobile/types";
import { clearCache, getCache } from "../../util/Cache";
import IzinListPage from "./Izinlistpage";
import IzinFormPage from "./IzinFormPage";
import { LeaveRequest } from "../../controller/mobile/Izintypes";
import { getSeedLeaveRequests } from "../../controller/mobile/Izinmockapi";
import LemburListPage from "./LemburListPage";
import LemburFormPage from "./LemburFormPage";
import { getLemburList } from "../../controller/mobile/Lemburapi";
import type { LemburEntry } from "../../controller/mobile/Lemburtypes";
import Profile from "./Profile";

export default function App(): React.ReactElement {
  const navigate = useNavigate();
  const [page, setPage] = useState<Page>("home");
  const [captureType, setCaptureType] = useState<AttendanceType>("masuk");

  const [employee, setEmployee] = useState<Karyawan>(mockCurrentEmployee);
  const [records, setRecords] = useState<AttendanceRecord[]>([]);
  const [leave, setLeave] = useState<LeaveRequest[]>([]);
  const [lembur, setLembur] = useState<LemburEntry[]>([]);

  useEffect(() => { initdata(); }, []);

  const checkUserDashboard = async (): Promise<boolean> => {
    try {
      const data = await getCache("current_user");
      if (!data || !data.nama) {
        navigate("/");
        return false;
      }
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const initdata = async () => {
    setEmployee(mockCurrentEmployee);
    setRecords([]);
    const ok = await checkUserDashboard();
    if (!ok) return;

    try {
      const data: any = await getCache('current_user');
      if (!data || (data && (data.id === undefined || data.id === null))) {
        console.warn('No current_user found in cache');
        return;
      }

      const recordsResp = await getSeedRecords(data.id);
      const leaveResp: any = await getSeedLeaveRequests(data.id);
      const lemburResp: any = await getLemburList(String(data.id));

      setEmployee(data);
      setRecords((recordsResp && recordsResp.data) || []);
      setLeave(leaveResp || []);
      setLembur(lemburResp || []);
    } catch (err) {
      console.error('Failed to load initial data:', err);
      setRecords([]);
      setLeave([]);
      setLembur([]);
    }
    // setPage("home");
  };

  const handleSignOut = async () => {
    clearCache('current_user');
    await checkUserDashboard();
  }
 
  const handleStartCapture = (type: AttendanceType) => {
    setCaptureType(type);
    setPage("capture");
  };
 
  const handleCaptureSuccess = async () => { await initdata(); setPage("home"); };
 
  return (
    <div className="min-h-screen w-full bg-slate-200 flex items-center justify-center sm:p-6">
      <div className="flex h-screen w-full max-w-sm flex-col overflow-hidden bg-slate-50 sm:h-[812px] sm:rounded-[2.5rem] sm:border-8 sm:border-slate-900 sm:shadow-2xl">
        <div className="flex items-center gap-3 border-b border-slate-200 bg-white px-5 py-3">
          {/* <Logo className="h-9 w-9" /> */}
          <img src={logo} alt="Logo" className="h-9 w-9 w-auto object-contain center" />
          <div className="leading-tight">
            <p className="text-[11px] font-bold uppercase tracking-wide text-blue-900">
              Bawaslu
            </p>
            <p className="text-[10px] text-slate-800">
              SiPasi - Sistem Kepagawaian Absensi
            </p>
          </div>
          <div className="ml-auto">
            <button className="rounded-full bg-red-500 px-3 py-1 text-[10px] font-semibold uppercase text-white shadow-sm hover:bg-red-600" onClick={handleSignOut}>
              Sign Out
            </button>
          </div>
        </div>
        {page === "home" && (
          <>
            <div className="flex-1 overflow-hidden">
                <HomePage
                  employee={employee}
                  records={records}
                  onNavigate={setPage}
                  onStartCapture={handleStartCapture}
                />
            </div>
            <BottomNav active={page} onNavigate={setPage} onTap={initdata}/>
          </>
        )}
 
        {page === "history" && (
          <>
            <div className="flex-1 overflow-hidden">
              <HistoryPage employee={employee} records={records} />
            </div>
            <BottomNav active={page} onNavigate={setPage} onTap={initdata}/>
          </>
        )}
 
        {page === "capture" && (
          <CapturePage
            type={captureType}
            id_karyawan={employee.id.toString()}
            onCancel={() => setPage("home")}
            onSuccess={handleCaptureSuccess}
          />
        )}

        {page === "izin" && (
          <>
            <IzinListPage
              requests={leave}
              onAddNew={() => setPage("izinlist")}
            />
            <BottomNav active={page} onNavigate={setPage} onTap={initdata}/>
          </>
        )}

        {page === 'izinlist' && (
          <>
            <IzinFormPage 
              idKaryawan={employee.id}
              onCancel={() => setPage("izin")}  
              onSuccess={() => { setPage("izin"); initdata(); }}
            />
          </>
        )}

        {page === "lembur" && (
          <>
            <LemburListPage
              entries={lembur}
              onAddNew={() => setPage("lemburlist")}
            />
            <BottomNav active={page} onNavigate={setPage} onTap={initdata}/>
          </>
        )}

        {page === 'lemburlist' && (
          <>
            <LemburFormPage 
              idKaryawan={employee.id}
              onCancel={() => setPage("lembur")}  
              onSuccess={() => { setPage("lembur"); initdata(); }}
            />
          </>
        )}

        {
          page === 'profile' && (
            <>
              <Profile 
                // employee={employee}
                onNavigate={setPage}
              />
              <BottomNav active={page} onNavigate={setPage} onTap={initdata}/>
            </>
          )
        }
      </div>
    </div>
  );
}